import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { PurchaseOrderLineRequirement } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderLineRequirementService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineRequirement,
  PurchaseOrderLineRequirement
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('PurchaseOrderLineRequirement', $localize`Purchase Order Line Requirement`);
  }

  createPurchaseOrderRequirements(
    purchaseOrderLineId: string,
    purchaseOrderLineRequirementId,
  ): Observable<PurchaseOrderLineRequirement[]> {
    return this.httpService.get<PurchaseOrderLineRequirement[]>(
      `${this.apiUrl}/CreatePurchaseOrderRequirements/${purchaseOrderLineId}${
        purchaseOrderLineRequirementId ? `/${purchaseOrderLineRequirementId}` : ''
      }`,
    );
  }

  /**
   * Rebuilds a line's components for a new quantity.
   *
   * Resolves to an empty string when the rebuild ran, or to a non-empty string when the line's
   * components have been hand-edited and would be lost - call again with `confirmed` true to go
   * ahead. Treat the text as a signal only: it is English, so the caller words its own question.
   * See PurchaseOrderLineRequirementController.UpdateRequirements.
   */
  updateRequirements(
    purchaseOrderLineId: string,
    quantity: number,
    confirmed = false,
    pickListChangeConfirmed = false,
  ): Observable<string> {
    return this.httpService.post<string>(`${this.apiUrl}/UpdateRequirements`, {
      purchaseOrderLineId,
      quantity,
      confirmed,
      pickListChangeConfirmed,
    });
  }

  /**
   * `pickListChangeConfirmed` is the Yes to the picking list warning on a make purchase order (see
   * PickListChangeService); a delete has no body, so it travels as a query parameter.
   */
  delete(id: string, pickListChangeConfirmed = false): Observable<any> {
    return this.httpService.delete(
      `${this.apiUrl}/${id}${pickListChangeConfirmed ? '?pickListChangeConfirmed=true' : ''}`,
    );
  }
}
